import classNames from "classnames";

interface ButtonProps {
  type: "button" | "submit" | "reset";
  children: React.ReactNode;
  size?: "small" | "medium" | "large";
  ariaLabel?: string;
  variant?: "solid" | "outline";
  buttonClass?: string;
  disabled?: boolean;
  isLoading?: boolean;
  contained?: boolean;
  onClick?: () => void;
}

export function Button({
  type,
  children,
  ariaLabel = "",
  variant = "solid",
  disabled = false,
  isLoading = false,
  contained = false,
  buttonClass = "",
  size = "medium",
  onClick = () => {},
}: ButtonProps) {
  const sizeClasses = {
    small: "min-w-8 min-h-8 py-1 px-2 text-sm",
    medium: "min-w-11 min-h-11 py-2 px-4 text-base",
    large: "min-w-12 min-h-12 py-3 px-6 text-lg",
  };

  return (
    <button
      type={type}
      disabled={disabled}
      aria-busy={isLoading}
      className={classNames(
        "focus:outline-none focus:ring-2",
        "rounded capitalize font-comfortaa font-medium transition-colors duration-200",
        "flex items-center justify-center",
        sizeClasses[size],
        {
          "cursor-not-allowed": disabled,
          "w-full": !contained,
          "w-fit px-2": contained,
          "bg-primary-500 text-white disabled:bg-opacity-40 hover:bg-primary-600 disabled:hover:bg-primary-500":
            variant === "solid",
          "bg-transparent border border-primary-500 text-primary-500 disabled:text-opacity-40 hover:bg-primary-50 disabled:hover:bg-transparent":
            variant === "outline",
          "cursor-wait": isLoading,
        },
        buttonClass,
      )}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {children}
    </button>
  );
}

export default Button;
